import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import SocialShare from "./components/SocialShare";
import Logo from "./logofgml.png";
import CandidatosDemandas from "./components/CandidatosDemandas";
import CandidatosTransparencia from "./components/CandidatosTransparencia";
import CandidatosCorrupcion from "./components/CandidatosCorrupcion";
import { useState, useEffect } from "react";
import Banner from "./especialvigilancia.jpeg";
import Contable from "./contable.png";
import Judicial from "./judicial.png";
import Folder from "./folder.png";

const NavItem = ({ currentTab, item, displayTab }) => (
  <li className="nav-item">
    <div
      className={currentTab === item.value ? "active nav-link" : "nav-link"}
      onClick={() => displayTab(item.value)}
    >
      <div class="d-flex align-items-center h-100">
        <img
          src={item.img}
          alt="Icon"
          width="auto"
          height="30"
          className="mr-2 d-none d-md-block"
        />
        <span>{item.label}</span>
      </div>
    </div>
  </li>
);

function App() {
  const [currentTab, setCurrentTab] = useState("demandas");
  const tabOptions = [
    {
      value: "demandas",
      label: "Candidatos con sentencias penales o fallos por demandas civiles",
      description: "Sentencias penales y civiles",
      img: Judicial,
    },
    {
      value: "transparencia",
      label:
        "Candidatos que en anteriores procesos no entregaron sus reportes financieros de campaña",
      description:
        "Omisión de entrega de informes de gastos en las elecciones del 2018 y 2020",
      img: Contable,
    },
    {
      value: "corrupcion",
      label: "Candidatos con expedientes por presuntos casos de corrupción",
      description:
        "Candidatos con expedientes por presuntos casos de corrupción",
      img: Folder,
    },
  ];

  const displayTab = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <div className="App">
      <header className="App-header mb-5 mt-4">
        <div className="row no-gutters align-items-center">
          <div className="col-md-9 col-sm-12 purple-bg">
            <h1 className="text-white px-5 pt-2 pb-1">
              Elecciones 2021: Antecedentes de candidatos
            </h1>
          </div>
          <div className="col-md-3 col-sm-12">
            <SocialShare
              url={process.env.REACT_APP_URL}
              text="Elecciones 2021: Antecedentes de candidatos"
            />
          </div>
        </div>
      </header>

      <div>
        <div className="container">
          <div>
            <img src={Banner} className="img-fluid banner" alt="Banner" />
          </div>
          <div className="description card-g width p-4 purple-light-bg rounded">
            <p className="purple">
              Herramienta interactiva de vigilancia ciudadana para revisar: <br/>1)
              Antecedentes penales y fallos por procesos civiles de los
              postulantes. <br/>2) Reporte de los candidatos que en procesos
              electorales pasados no informaron sus ingresos y gastos de
              campaña. <br/>3) Candidatos investigados por presunta corrupción.
            </p>
          </div>

          <div>
            <ul className="nav nav-tabs nav-fill">
              {tabOptions.map((tab) => (
                <NavItem
                  currentTab={currentTab}
                  item={tab}
                  displayTab={displayTab}
                  key={tab.value}
                />
              ))}
            </ul>
            {currentTab === "demandas" && (
              <div id="candidatos-demandas">
                <CandidatosDemandas />
              </div>
            )}
            {currentTab === "transparencia" && (
              <div id="candidatos-sin-transparencia">
                <CandidatosTransparencia />
              </div>
            )}
            {currentTab === "corrupcion" && (
              <div id="candidatos-corrupcion">
                <CandidatosCorrupcion />
              </div>
            )}
          </div>
        </div>
      </div>
      <br></br>
      <br></br>
      <footer className="py-5">
        <hr></hr>
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-3 col-xs-12 mr-md-5 mb-4 mb-md-0">
              <a href="https://fundacionmohme.org/" target="_blank">
                <img src={Logo} className="" alt="Fundación Mohme" />
              </a>
              <div className="mt-2">
                <small>
                  Una iniciativa de vigilancia electoral del Proyecto Talleres
                  de Periodismo de la Fundación Gustavo Mohme Llona.
                </small>
              </div>
            </div>

            <div className="col-md-4 col-xs-12">
              <div className="">
                <div>
                  <small>Coordinacion: Wilber Huacasi</small>
                </div>
                <div>
                  <small>Desarrollo web: Melissa Chávez</small>
                </div>
                <div>
                  <small>
                    Colaboradores: Ghiomara Rafaele (estudiante de periodismo -
                    UNMSM) e Iris Bayona (estudiante de periodismo – UNP)
                  </small>
                </div>
                <div>
                  <small className="text-center">Fuente: JNE y ONPE</small>
                </div>
                <div class="mt-2">
                  <small>info@fundacionmohme.org</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
